export const mustachePlaceholderRegex = /^\{{2,3}[a-zA-Z0-9._-]+\}{2,3}$/;
